<h2 mat-dialog-title>{{data.dialogTitle}}</h2>
<mat-dialog-content class="dialog" [innerHTML]="safeHtmlContent"></mat-dialog-content>
<mat-dialog-actions align="end">
  @if (data.isCancelButton) {
    <button mat-button [mat-dialog-close]="false">בטל</button>
  }
  @if (data.isOkayButton) {
    <button mat-button [mat-dialog-close]="true" cdkFocusInitial>אישור</button>
  }
</mat-dialog-actions>
